import React from 'react';
import classnames from 'classnames';
import { Translate } from 'react-localize-redux';

class TabLink extends React.Component {
    render() {
        return (<li className={classnames({ 'tab-link': true, 'is-active': this.props.selected === this.props.type })}>
            <a className={`text-wrap ${this.props.selected === this.props.type ? 'is-active' : ''}`}
                onClick={() => this.props.onSelect(this.props.type)} style={{ cursor: 'pointer' }}>
                <div className="tabs-icon-wrap">{this.props.icon}</div>
                <div className="tabs-text-container">
                    {<Translate id={this.props.titleKey} />}
                    {this.props.descriptionKey && <div className="tabs-desc-wrap"><Translate id={this.props.descriptionKey} options={{ renderInnerHtml: true }} /></div>}
                </div>
            </a>
            {this.props.hr && <hr />}
        </li>);
    }
}

export default (TabLink);